import { render } from "./RadioComp.vue?vue&type=template&id=94337c6e&scoped=true"
import script from "./RadioComp.vue?vue&type=script&lang=js"
export * from "./RadioComp.vue?vue&type=script&lang=js"

import "./RadioComp.vue?vue&type=style&index=0&id=94337c6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94337c6e"]])

export default __exports__